<template lang="pug">
.loader-container(v-if="show")
  .content-container
    .content
      v-progress-circular(:size="120", color="green", :width="6", :indeterminate="true")
      h2.loader-title {{ text }}
</template>

<script>
export default {
  watch: {
    show(value) {
      this.syncBodyScrollLock(value);
    }
  },

  mounted() {
    this.syncBodyScrollLock(this.show);
  },

  beforeDestroy() {
    this.syncBodyScrollLock(false);
  },

  computed: {
    show() {
      return this.$store.state.loader.show;
    },
    text() {
      return this.$store.state.loader.text || "Carregando...";
    }
  },

  methods: {
    syncBodyScrollLock(shouldLock) {
      if (typeof document === "undefined" || !document.body) return;

      document.body.style.overflow = shouldLock ? "hidden" : "";
    }
  }
};
</script>

<style scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
}

.content-container {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: radial-gradient(
    ellipse closest-side,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.1) 70%,
    rgba(255, 255, 255, 0.2) 90%
  );
  pointer-events: none;
  border-radius: 10px;
  backdrop-filter: blur(5px);
}

.content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: larger;
  z-index: 999;
}

.loader-title {
  margin-top: 20px;
  font-weight: 400 !important;
  font-size: 40px !important;
}
</style>
